import { combineReducers } from 'redux';

import transactions from './settings';

const reducer = combineReducers({
  [transactions.name]: transactions.reducer,
});

export default reducer;
